import React from 'react'

import ConversionsGraphSection from './ConversionsGraphSection'
import LeadGraphSection from './LeadGraphSection'

const ConversionRelatedGraphSections = ({ graphData }) => {
  const { conversionsData, leadData } = graphData

  if (Number(conversionsData?.total) > 0) {
    // if conversions > 0 then show conversions
    return <ConversionsGraphSection rawGraphData={conversionsData} />
  } else if (Number(leadData?.total) > 0) {
    // If conversions = 0 but lead > 0 then show a column called Leads with the figure.
    return <LeadGraphSection rawGraphData={leadData} />
  }
  // todo PBR-1057 add if else for complete_registration, currently request fails with this insight
  // If conversions and leads = 0 but complete_registration > o then show a column called Complete Registration.
  // todo PBR-1057 add if else for landing_page_view, currently request fails with this insight
  // If conversions, lead and complete_registration = 0 but landing_page_view > 0 then show a column called Landing Page Views
  else {
    return null
  }
}

export default ConversionRelatedGraphSections
